
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'
import CustomButton from '../customButton/CustomButton';


const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      borderRadius: 12,
      padding: theme.spacing(2),
      backgroundColor: '#f9f9f9',
      width: '100%',
      boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
    },
    title: {
      fontWeight: 'bold',
      fontSize: '1.25rem',
      color: '#333'
    },
    content: {
      fontSize: '1rem',
      color: '#555'
    },
    actions: {
      justifyContent: 'flex-end'
    },
    cancelButton: {
      color: '#888'
    },
    confirmButton: {
      backgroundColor: '#1976d2',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#1565c0'
      }
    }
  }));
  

const CommonDialog = ({
  open=false,
  title,
  content,
  onClose,
  onConfirm,
  hideSubmitBtn,
  hideInviteBtn,
  onInviteAction = ()=>{},
  InviteButtonText ='Invite',
  disabled,
  confirmText = "Confirm",
  cancelText = "Cancel"
}) => {
  
    const classes = useStyles();


    return (
   
    <Dialog 
        open={open} 
        // onClose={onClose}
        classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle >{title}</DialogTitle>
      <DialogContent >
        <Typography>{content}</Typography>
      </DialogContent>
      <DialogActions>
        {cancelText && 
        <CustomButton onClick={onClose}>{cancelText}</CustomButton>}
        {
          !hideSubmitBtn &&
        <CustomButton onClick={onConfirm} disabled={disabled} variant="contained" color="primary">
          {confirmText}
        </CustomButton>
        }
        {
          hideInviteBtn &&
        <CustomButton onClick={onInviteAction} disabled={disabled} variant="contained" color="primary">
          {InviteButtonText}
        </CustomButton>
        }
      </DialogActions>
    </Dialog>
    
  );
};

export default CommonDialog;
